export const selectIsLoading = state => !state.init.isFinished || state.loading
export const selectPlant = state => state.plant
export const selectLocation = state => state.location
export const selectTimezone = state => state.config.timezone
export const selectToken = state => state.config.token
export const selectDurations = state => state.changeovers.durations
export const selectCounts = state => state.changeovers.counts
